module.exports = __webpack_public_path__ + "static/media/life-faq-banner-graphic.081b3e98.png";